export default __webpack_public_path__ + "assets/models/82f7b3ec59007eddeed388338b6fd442.glb";